/**
 * The creation flow's URLs, absolute — `Navigate` resolves `..` against the ROUTE hierarchy rather than
 * the URL, which for nested routes is a different place than it reads like.
 */
export const FOOD_PROFILES_PATH = '/eating-style/food-profiles'
export const CREATE_PATH = `${FOOD_PROFILES_PATH}/create`
export const CREATE_RULES_PATH = `${CREATE_PATH}/rules`

export const profileHubPath = (profileId: string) => `${FOOD_PROFILES_PATH}/${profileId}`
